
const state = {
  additional_instructions: '',
  status_id: undefined,
}

export const requiredFields = []

export default state
